import { QueryOptions } from "../components/Common/useQuery";
import useUserQuery from "../components/Common/useUserQuery";
import { useSelectedBusiness } from "../components/UserAccess/useSelectedBusiness";
import { TransportDto } from "./useGetTransports";

export type SiteTransportDto = Omit<TransportDto, 'sites'>;

const useGetSiteTransports = (siteId: string, options?: QueryOptions<SiteTransportDto[]>) => {
  const business = useSelectedBusiness();
  return useUserQuery<SiteTransportDto[]>({
    path: `/api/businesses/${business.id}/transports/siteTransports?siteId=${siteId}`,
  }, options);
}

export default useGetSiteTransports;
